import { NudosGenericModal, NudosModalContent } from '../../../../../components/NudosComponents';
import ModalAddPaymentLinkContent from './ModalAddPaymentLinkContent';
import { IlogisticServiceTrelloCardData } from '../../../../../types/services';
import './ModalAddPaymentLink.scss';

const ModalAddPaymentLink = ({
  closeModalCallback,
  logisticServiceData,
  updateTrelloDataCallback
}: {
  closeModalCallback: () => void;
  logisticServiceData: IlogisticServiceTrelloCardData;
  updateTrelloDataCallback?: () => void;
}) => {
  return (
    <div className="ModalAddPaymentLink">
      <NudosGenericModal
        closeModalCallback={closeModalCallback}
        modalContent={
          <NudosModalContent
            toCloseModal={closeModalCallback}
            customWidth="580px"
            customHeight="410px"
            modalContentTitle="Link de pago"
            CustomModalComponent={
              <ModalAddPaymentLinkContent
                closeModalCallback={closeModalCallback}
                logisticServiceData={logisticServiceData}
                updateTrelloDataCallback={updateTrelloDataCallback}
              />
            }
          />
        }
      />
    </div>
  );
};

export default ModalAddPaymentLink;
